import G from './Getters';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ExpansionTemplateInfo, ExpansionWindowFocusContext } from './Contexts';


import FigureImageExpansionTemplateLayout from './FigureImageExpansionTemplateLayout';

export default function FigureImageExpansionTemplateLayoutContainer({template,onItemClick, thumbnail, onEvent}){


  let { nodes } = template;

   

  const value = useMemo(() => {
    return {thumbnail, template}
  },[thumbnail,template])



  return (
    <>
    <ExpansionTemplateInfo.Provider value={value}>
      
      <FigureImageExpansionTemplateLayout {...{
        nodeId:"root",
        nodes, 
        //computedDimensions, 
        template, 
        onEvent,
      }}/>

    </ExpansionTemplateInfo.Provider>
    </>

  )
}
